//全局根路径
const basePath = process.env.VUE_APP_API_URL

export default {
    install(Vue) {

        //加载图片路径渲染图片 +"/upload",图片加载路径
        Vue.prototype.loadUrl = function loadUrl(url) {
            return `${basePath}/api/file/downloadFile/${url}`
        }
        Vue.prototype.download = basePath + '/api/file/downloadFile/'

        Vue.prototype.uploadImg = function uploadImg() {
            return basePath + '/api/file/Uploader/annexpic'
        }

        Vue.prototype.uploadHeaders = function uploadHeaders() {
            return { Authorization:  window.localStorage.getItem("token")}
        }

        Vue.prototype.uploadFiles = function uploadFiles() {
            return basePath + '/api/file/Uploader/annex'
        }

        Vue.prototype.showImg = function showImg() {
            return basePath + '/api/file/Image'
        }
        Vue.prototype.echoImg = function echoImg(url) {
            return `${basePath}/api/file/minio/front/inline?filePath=${url}`
        }

        Vue.prototype.toDate = function toDate(v, format) {
            format = format ? format : 'yyyy-MM-dd HH:mm'
            if (!v) return ''
            var d = v
            if (typeof v === 'string') {
                if (v.indexOf('/Date(') > -1) {
                    d = new Date(parseInt(v.replace('/Date(', '').replace(')/', ''), 10))
                } else {
                    d = new Date(Date.parse(v.replace(/-/g, '/').replace('T', ' ').split('.')[0]))
                }
            } else {
                d = new Date(v)
            }
            var o = {
                'M+': d.getMonth() + 1,
                'd+': d.getDate(),
                'h+': d.getHours(),
                'H+': d.getHours(),
                'm+': d.getMinutes(),
                's+': d.getSeconds(),
                'q+': Math.floor((d.getMonth() + 3) / 3),
                'S': d.getMilliseconds()
            }
            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
                }
            }
            return format
        }

        // 日期格式化（全）
        Vue.prototype.formatNumber = function formatNumber(n) {
            n = n.toString()
            return n[1] ? n : '0' + n
        }
        // 日期格式化（全）
        const formatNumber = function (n) {
            n = n.toString()
            return n[1] ? n : '0' + n
        }

        /**
         * 时间戳和日期转换(年月日+时间)
         * @param times
         */
        Vue.prototype.formatDateTime = function formatDateTime(times) {
            let now = new Date(times)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let date = now.getDate()
            let hour = now.getHours()
            let minute = now.getMinutes()
            let second = now.getSeconds()
            return year + '-' + formatNumber(month) + '-' + formatNumber(date) + ' ' + formatNumber(hour) + ':' + formatNumber(minute) + ':' + formatNumber(second)
        }

        /**
         * 时间戳和日期转换（年月日 / ）
         * @param {*} times
         */
        Vue.prototype.formatDate = function formatDate(times) {
            let now = new Date(times)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let date = now.getDate()
            return year + '/' + formatNumber(month) + '/' + formatNumber(date)
        }
        /**
         * 时间戳和日期转换（年月日 - ）
         * @param {*} times
         */
        Vue.prototype.formatDateH = function formatDateH(times) {
            let now = new Date(times)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let date = now.getDate()
            return year + '-' + formatNumber(month) + '-' + formatNumber(date)
        }
        /**
         * 时间戳和日期转换（年月日）
         * @param {*} times
         */
        Vue.prototype.formatDateYMD = function formatDateYMD(times) {
            let now = new Date(times)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            let date = now.getDate()
            return year + '年' + formatNumber(month) + '月' + formatNumber(date) + '日'
        }

        // 日期格式化
        Vue.prototype.parseTime = function parseTime(time, pattern) {
            if (arguments.length === 0 || !time) {
                return null
            }
            const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
            let date
            if (typeof time === 'object') {
                date = time
            } else {
                if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                    time = parseInt(time)
                } else if (typeof time === 'string') {
                    time = time.replace(new RegExp(/-/gm), '/')
                }
                if ((typeof time === 'number') && (time.toString().length === 10)) {
                    time = time * 1000
                }
                date = new Date(time)
            }
            const formatObj = {
                y: date.getFullYear(),
                m: date.getMonth() + 1,
                d: date.getDate(),
                h: date.getHours(),
                i: date.getMinutes(),
                s: date.getSeconds(),
                a: date.getDay()
            }
            const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
                let value = formatObj[key]
                if (key === 'a') {
                    return ['日', '一', '二', '三', '四', '五', '六'][value]
                }
                if (result.length > 0 && value < 10) {
                    value = '0' + value
                }
                return value || 0
            })
            return time_str
        }

        /**
         * 获取微信授权code
         */
        Vue.prototype.getUrlParam = function getUrlParam(name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
        }

        // 时间区间
        Vue.prototype.isDuringDate = function isDuringDate(beginDateStr, endDateStr) {
            let curDate = new Date().getTime(),
                beginDate = new Date(beginDateStr).getTime(),
                endDate = new Date(endDateStr).getTime()

            endDate += 24 * 60 * 60 * 1000

            if (curDate >= beginDate && curDate <= endDate) {
                return 0
            }
            if (curDate >= endDate) {
                return -1
            }
            if (curDate <= beginDate) {
                return 1
            }
        }

        Vue.prototype.downLoadBlobFile = function downLoadBlobFile(data = 'Blob', fileName = 'string', type = 'string') {
            let name = fileName || new Date().toLocaleDateString()
            let typeStr = type ? type : 'application/vnd.ms-excel'

            if (window.navigator.msSaveOrOpenBlob) {
                const blob = new Blob([data], {type: typeStr})
                navigator.msSaveBlob(blob, name)
            } else {
                const excelBlob = new Blob([data], {type: typeStr})
                let oa = document.createElement('a')

                oa.href = URL.createObjectURL(excelBlob)
                oa.download = name
                document.body.appendChild(oa)
                oa.click()
            }
        }
    }
} 